import { Component, Input } from '@angular/core';
import { QueryService } from '../../comun/services/query.service';
import { MascotasComponent } from '../mascotas.component';

@Component({
  selector: 'app-mascota-edit',
  templateUrl: './mascota-edit.component.html',
  styleUrls: ['./mascota-edit.component.css']
})
export class MascotaEditComponent {
  @Input() mascota: any = {};
  personalidades: any[] = [];

  constructor(public app: MascotasComponent,
              private query: QueryService) { }

  ngOnInit() {
    this.getPersonalidades();
  }

  ngAfterViewInit() {
    this.app.imagepopup.init();
  }

  getEnergiaTexto(): string {
    switch (this.mascota.ma_energia) {
      case 1: return '💤 Bajo (tranquilo, mayor, poco activo)';
      case 2: return '⚡ Medio (activo pero equilibrado)';
      case 3: return '🔥 Alto (muy activo, necesita ejercicio frecuente)';
      case 4: return '🚀 Muy alto (extremadamente activo, necesita ejercicio constante)';
      default: return '';
    }
  }  

  getPersonalidades() {
    this.query.query('valores', 'GET', { grupo: 'PERSONALIDAD'}).subscribe((resultado:any) => {
      this.personalidades = resultado.registros;
      if (Array.isArray(this.mascota.atributos)) {
        this.app.personalidadesSeleccionadas = this.personalidades.filter(p =>
          this.mascota.atributos.some((a: any) => (a.at_atributo || '').trim().toLocaleLowerCase() === (p.va_nombre || '').trim().toLocaleLowerCase())
        );
      } else {
        this.app.personalidadesSeleccionadas = [];
      }
    });
  }

  onCheckChange(event: any, personalidad: any) {
    if (event.target.checked) {
      if (!this.app.personalidadesSeleccionadas.some((p: any) => p.va_nombre === personalidad.va_nombre)) {
        this.app.personalidadesSeleccionadas.push(personalidad);
      }
    } else {
      this.app.personalidadesSeleccionadas = this.app.personalidadesSeleccionadas.filter(
        p => p.va_nombre !== personalidad.va_nombre
      );
    }
  }

  /*onSwitchChange(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    
    //this.mascota.ma_novisible = isChecked ? '' : 'X';
  }*/
}
